import { DataTestId, TextKey } from '@mews-commander/enums';
import { ConnectedEditDialogForm } from '@mews-commander/legacy-form';
import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import { LocalizedText } from '@mews/framework';
import { closeDialog } from '../../../../../modules/dialog/reducer';
import { isDialogOpen } from '../../../../../modules/dialog/selectors';
import { SendEmailDialogForm } from '../SendInvoiceToEmailDialog';
import { FORM_NAME } from '../SendInvoiceToEmailDialog/constants';
import { REMINDER_DIALOG_NAME } from './constants';

export const SendReminderToEmailDialog = () => {
    const dispatch = useCommanderThunkDispatch();
    const active = useCommanderSelector((state) => isDialogOpen(state, { name: REMINDER_DIALOG_NAME }));

    const onClose = () => {
        dispatch(closeDialog(REMINDER_DIALOG_NAME));
    };

    return (
        <ConnectedEditDialogForm
            active={active}
            buttonsSize="medium"
            formName={FORM_NAME}
            primaryButtonTextKey={TextKey.Send}
            primaryButtonDataTestId={DataTestId.SendReminderSendButton}
            secondaryButtonTextKey={TextKey.Cancel}
            closeDialog={onClose}
            size="small"
            title={<LocalizedText textKey={TextKey.SendReminder} />}
            floatingPanel
        >
            <SendEmailDialogForm type="SendReminder" />
        </ConnectedEditDialogForm>
    );
};
